module.exports = __webpack_public_path__ + "img/HQ-Z7035-V2.5125be13.jpg";